import { render, staticRenderFns } from "./OrderStatusesList.vue?vue&type=template&id=5c5bb677"
import script from "./OrderStatusesList.vue?vue&type=script&lang=js"
export * from "./OrderStatusesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports